// extracted by mini-css-extract-plugin
export default {"solarSystemTypeContainer":"solar-system-type_solarSystemTypeContainer__nGC1q","borderDarkMode":"solar-system-type_borderDarkMode__i3i+s","title":"solar-system-type_title__IQHOL"};